import { Box, Typography } from "@mui/material";
import logo from "../assets/eXXI_logo.png";

export default function Footer() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        width: "100%",
      }}
    >
      {/* lewa kolumna z logo */}
      <Box
        sx={{
          width: { xs: "100%", md: "25%" },
          flexShrink: 0,
          backgroundColor: "#FFFFFF",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Logo exxi"
          sx={{
            width: "100%",
            height: "auto",
            maxWidth: "150px",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* prawa kolumna na niebieskim tle */}
      <Box
        sx={{
          flex: "1 1 auto",
          backgroundColor: "#29235C",
          p: { xs: 2, md: 4 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: { xs: "flex-start", md: "flex-start" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "24px" },
            color: "#FFFFFF",
            mb: 0,
            fontWeight: "bold",
          }}
        >
          eXXI sp. z o.o.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "16px", md: "18px" },
            color: "#FFFFFF",
            mb: 0,
          }}
        >
          ul. Racławicka 146
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "16px", md: "18px" },
            color: "#FFFFFF",
            mb: 0,
          }}
        >
          02-117 Warszawa
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "16px", md: "18px" },
            color: "#FFFFFF",
            mb: 0,
          }}
        >
          e-mail: info@eXXI.pl
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "16px", md: "18px" },
            color: "#FFFFFF",
            mb: 0,
          }}
        >
          tel. +48 22 100 10 05
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "16px", md: "18px" },
            color: "#FFFFFF",
            mb: 2,
          }}
        >
          fax. +48 22 100 10 99
        </Typography>

        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "16px", md: "18px" },
            color: "#FFFFFF",
            mb: 0,
          }}
        >
          Regon: 140776798, NIP: 5242593325
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "16px", md: "18px" },
            color: "#FFFFFF",
            mb: 0,
          }}
        >
          KRS: Sąd Rejonowy dla m.st. Warszawy w Warszawie, XII Wydział
          Gospodarczy KRS, Nr KRS 0000273281
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "16px", md: "18px" },
            color: "#FFFFFF",
          }}
        >
          Kapitał zakładowy 57 500 PLN opłacony w całości{" "}
        </Typography>
      </Box>
    </Box>
  );
}
